import { useCallback } from "react";
import { Button, Group } from "@mantine/core";

interface ReportReviewGlobalActionsProps {
  disabled: boolean;
  onChange: (required: boolean) => void;
}

export function ReportReviewGlobalActions({
  disabled,
  onChange,
}: ReportReviewGlobalActionsProps) {
  const handleRequire = useCallback(() => onChange(true), [onChange]);
  const handleMakeOptional = useCallback(() => onChange(false), [onChange]);
  return (
    <Group justify="flex-end">
      <Button onClick={handleRequire} disabled={disabled}>
        Require review for all
      </Button>
      <Button variant="light" onClick={handleMakeOptional} disabled={disabled}>
        Make all optional…
      </Button>
    </Group>
  );
}
